"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./getEnvironmentFromHostname.cjs");function o(){return n.getEnvironmentFromHostname()==="production"}exports.isProductionEnvironment=o;
//# sourceMappingURL=isProductionEnvironment.cjs.map
